module.exports = __webpack_public_path__ + "static/media/LATINS_COMMUNS-AVEC-VUE-TERRASSE.e421d81b.jpg";